export const formatNumber = (number, maximumFractionDigits = 0) => {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: 0,
  }).format(number);
}

export const formatPercentage = (number, maximumFractionDigits = 2) => {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: 0,
  }).format(number);
}

export const formatPhoneNumber = (number) => {
  const n = number.toString()
  return `${n.slice(0, 2)} ${n.slice(2, 5)}-${n.slice(5, 8)}-${n.slice(8)}`;
}